<template>
  <div class="box1">
    <img class="logo" src="../../../assets/coursePage/acp/box1/logo.png" />
    <div class="subTitle">大数据工程师培养计划</div>
    <div class="page-title">阿里云ACP认证课</div>
    <div class="text">
      <img class="icon" src="../../../assets/coursePage/acp/box1/icon.png" />
      理论精讲，实战赋能，40小时快速通关拿证
    </div>
    <div class="text">
      <img class="icon" src="../../../assets/coursePage/acp/box1/icon.png" />
      基于阿里云标准深入研发课程，助力轻松掌握大数据云开发
    </div>
    <div class="text">
      <img class="icon" src="../../../assets/coursePage/acp/box1/icon.png" />
      三大领域实战串联考试大纲要点，开箱即用
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.box1 {
  height: 800px;
  background-image: url(../../../assets/coursePage/acp/box1/bg.png);
  background-size: 100% 100%;
  padding: 48px 32px 0 48px;
  box-sizing: border-box;

  .logo {
    width: 458.5px;
  }
  .subTitle {
    width: 436px;
    height: 60px;
    background: url(../../../assets/coursePage/acp/box1/bg02.png);
    background-size: 100% 100%;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 60px;
    letter-spacing: 1px;

    margin: 60px 0 39px;
    padding-left: 62px;
    box-sizing: border-box;
  }

  .page-title {
    font-family: PingFangSC-Semibold;
    font-size: 66px;
    font-weight: 600;
    font-stretch: normal;
    line-height: 66px;
    letter-spacing: 3px;
    color: #332114;
    margin-bottom: 60px;
  }

  .slogan {
    width: 472px;
    height: 48px;
    display: flex;
    margin-top: 40px;
    span {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 48px;
    }

    .left {
      width: 176px;
      height: 48px;
      position: relative;
      background: linear-gradient(159deg, #58d1ff 0%, #3c7bff 100%);
      border-radius: 24px;
      color: #ffffff;
      text-align: center;
      z-index: 2;
    }

    .right {
      width: 342px;
      height: 48px;
      position: relative;
      padding-left: 62px;
      z-index: 1;
      color: #0063ff;
      border-radius: 24px;
      border: 1px solid #0063ff;
      margin-left: -46px;
      box-sizing: border-box;
    }
  }

  .info {
    margin-top: 40px;
    li {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #425a7c;
      line-height: 56px;
      padding-left: 21px;
      position: relative;
      &:after {
        content: "·";
        position: absolute;
        top: 0;
        left: 0;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #425a7c;
        line-height: 56px;
      }
    }
    li:last-child {
      &:after {
        content: "";
        display: none;
      }
    }
  }
  .text {
    display: flex;
    align-items: flex-start;
    margin-bottom: 29px;
    background: url(../../../assets/coursePage/acp/box1/bg04.png) no-repeat;
    background-size: 100% 100%;
    background-origin: left center;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 0px;
    color: #33210f;
    padding: 10px;
    img {
      width: 28px;
      margin-right: 14px;
    }
  }
  .text:nth-child(2) {
    background: url(../../../assets/coursePage/acp/box1/bg03.png) no-repeat;
    background-size: contain;
    background-origin: left center;
  }
}
</style>
